import Vue from "vue"
import Vuex from "vuex"
import { loader } from "./modules/loader";
import { msgErro } from "./modules/msgErro"
import { msgSucesso } from "./modules/msgSucesso"
import { auth } from "./modules/auth"
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    loader,
    msgErro,
    msgSucesso,
    auth
  }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js